// About Premium endpoints
export const ABOUT_ENDPOINTS = {
  ABOUT_LINKS: '/papi/content/premium-methodology-list',
  ABOUT_MENU: '/papi/content/premium-methodology-menu',
  ABOUT_SECTION: '/papi/content/premium-methodology-section',
};

// Delegates endpoints
export const DELEGATE_ENDPOINTS = {
  ACTIVE_DELEGATES_BY_PHYSICIAN: '/papi/secure/delegates/active-by-physician',
  DELEGATES: '/papi/secure/delegates',
};

// Access endpoints
export const ACCESS_ENDPOINTS = {
  FETCH_MY_DELEGATES: '/papi/secure/delegates/my-delegates',
  SEARCH_PIXE_USERS: '/papi/secure/pixe-users/search',
  FETCH_PIXE_USER_BY_MPIN: '/papi/secure/pixe-users/mpin',
  SEARCH_PHYSICIANS: '/papi/secure/physicians',
  REQUEST_PHYSICIAN: '/papi/secure/request-physician',
  DELETE_PHYSICIAN_REQUEST: '/papi/secure/request-physician/delete',
  DELETE_GROUP_ACCESS: '/papi/secure/groups',
  VALIDATE_GROUP: '/papi/secure/groups',
  VALIDATE_PIN: '/papi/secure/validate-pin',
  CHECK_REGISTRATION: '/papi/secure/physicians/check-registration',
  ADD_DELEGATE: '/papi/secure/delegates',
  DENY_DELEGATE: '/papi/secure/delegates',
  APPROVE_DELEGATE: '/papi/secure/delegates',
  DELETE_DELEGATE: '/papi/secure/delegates',
  FETCH_MY_DELEGATE: '/papi/secure/delegates',
  FETCH_MY_ACTIVE_DELEGATES: '/papi/secure/delegates/active-by-physician',
  VALIDATE_USER: '/papi/secure/validate',
  MY_PHYSICIANS: '/papi/secure/my-physicians',
  GROUPS_BY_USER: '/papi/secure/groups/by-user',
  SEARCH_BY_NAME: '/papi/secure/pixe-user/by-name',
  PIXE_USER_GET_BY_MPIN: '/papi/secure/pixe-user/by-mpin',
  REGISTER_PHYSICIAN: '/papi/secure/registration/validate-physician',
  SECURE_PIXE_USER: '/papi/secure/pixe-user',
};

// Auth-related endpoints
export const AUTH_ENDPOINTS = {
  // User endpoints
  PIXE_USER_SEARCH_BY_NAME: '/papi/secure/pixe-users/search',
  PIXE_USER_GET_BY_MPIN: '/papi/secure/pixe-users/mpin',
  SECURE_VALIDATE_PHYSICIAN: '/papi/secure/validate-physician',
  USER_COUNTS_INTERNAL: '/papi/user-counts/internal',
  USER_COUNTS_EXTERNAL: '/papi/user-counts/external',

  // Auth endpoints
  VALIDATE: '/papi/secure/validate',
  LOGOUT: '/logout',
};

// Content endpoints
export const CONTENT_ENDPOINTS = {
  ALERTS: '/papi/content/alerts',
  SECURE_ALERTS: '/papi/secure/content/alerts',
  CONTENT: '/papi/content/data',
  DOCUMENTS: '/papi/content/documents',
  DOCUMENTS_DOWNLOAD: '/papi/content/download/document',
  NEWS: '/papi/content/news',
};

// Case endpoints
export const CASE_ENDPOINTS = {
  ADJUDICATION: '/papi/secure/requests/adjudication',
  CASE_CLOSED_EPISODES: '/papi/secure/case/episodes',
  CASE_CLOSED_MEASURES: '/papi/secure/case/measures',
  CASE_CLOSED_TREATMENT_SETS: '/papi/secure/case/treatment-sets',
  CASE_DETAILS: '/papi/secure/case/details',
  CASE_STATUS_CASES: '/papi/secure/case/status',
  CASE_SUBMIT: '/papi/secure/case/submit',
  CASE_SUMMARY: '/papi/secure/case/summary',
  CHECK_REGISTRATION: '/papi/secure/physicians/check-registration',
};

// Communication Center endpoints
export const COMM_CENTER_ENDPOINTS = {
  COMM_CENTER_COUNTS: '/papi/secure/comm-center/counts',
  COMM_CENTER_MESSAGE_ATTACHMENT: '/papi/secure/comm-center/messages/attachment',
  COMM_CENTER_MESSAGES: '/papi/secure/comm-center/messages',
  COMM_CENTER_MESSAGES_SENT_BY_USER: '/papi/secure/comm-center/messages/sent-by-user',
  COMM_CENTER_NOTIFICATION_DOWNLOAD: '/papi/secure/comm-center/notifications/download',
  COMM_CENTER_NOTIFICATIONS_FOR_USER: '/papi/secure/comm-center/notifications/for-user',
  COMM_CENTER_TICKET: '/papi/secure/comm-center/ticket',
  COMM_CENTER_TICKET_STATUS: '/papi/secure/comm-center/ticket-status',
  COMM_CENTER_TICKETS_FOR_USER: '/papi/secure/comm-center/tickets-for-user',
  CONTACT_PREMIUM_MESSAGES: '/papi/messages/contact-premium',
};

// Cost Episodes endpoints
export const COST_EPISODE_ENDPOINTS = {
  COST_EPISODES: '/papi/secure/cost/episodes',
  COST_EPISODE_DESCRIPTION: '/papi/secure/cost/episode-description',
  COST_EPISODE_EBM_ATTRIBUTION: '/papi/secure/cost/episode-ebm-attribution',
  COST_EPISODE_EXCLUSION: '/papi/secure/cost/episode-exclusion',
  COST_EPISODE_PATIENTS: '/papi/secure/cost/episode-patients',
  COST_EPISODE_PEG_ATTRIBUTION: '/papi/secure/cost/episode-peg-attribution',
  COST_EPISODE_RECON_ATTACHMENT: '/papi/secure/cost-episode/recon/attachment',
  COST_EPISODE_SERVICE_DETAILS: '/papi/secure/cost/episode-service-details',
  COST_EPISODE_SERVICE_DETAIL_EXCLUSION: '/papi/secure/cost/episode-service-detail-exclusion',
  COST_EPISODE_SEVERITIES: '/papi/secure/cost/episode-severities',
  COST_EPISODE_SEVERITY_CONDITIONS: '/papi/secure/cost/episode-severity-conditions',
  COST_EPISODE_SEVERITY_EXCLUSION: '/papi/secure/cost/episode-severity-exclusion',
  COST_EPISODE_WEIGHTED: '/papi/secure/cost/episode-weighted',
};

// Cost Patients endpoints
export const COST_PATIENT_ENDPOINTS = {
  COST_PATIENTS: '/papi/secure/costPatient/cost-patients',
  COST_PATIENT_EXCLUSION: '/papi/secure/costPatient/cost-patient-exclusion',
  COST_PATIENT_GRAPH: '/papi/secure/costPatient/cost-patients-graph',
  COST_PATIENT_PATIENTS: '/papi/secure/costPatient/cost-patient-patients',
  COST_PATIENT_RECON_ATTACHMENT: '/papi/secure/cost-patient/recon/attachment',
  COST_PATIENT_RISK_CATEGORIES: '/papi/secure/costPatient/cost-patients-risk-category',
  COST_PATIENT_RISK_EXCLUSION: '/papi/secure/costPatient/cost-patients-risk-exclusion',
  COST_PATIENT_SERVICE_ATTRIBUTION: '/papi/secure/costPatient/cost-patients-service-attribution',
  COST_PATIENT_SERVICE_DETAILS: '/papi/secure/costPatient/cost-patients-service-details',
  COST_PATIENT_SERVICE_DETAILS_EXCLUSION: '/papi/secure/costPatient/cost-patients-service-details-exclusion',
};

// Designation endpoints
export const DESIGNATION_ENDPOINTS = {
  DESIGNATION_OVERVIEW: '/papi/secure/designation-overview',
  DESIGNATION_PHASE: '/papi/secure/odm/designation-phase',
  DESIGNATION_TRANSLATION: '/papi/content/desgination-translation',
};

// FAQ endpoints
export const FAQ_ENDPOINTS = {
  FAQ_LINKS: '/papi/content/faq/faq-links',
  FAQ_LIST: '/papi/content/faq/faq-list',
  FAQ_SECTION: '/papi/content/faq/faq-section',
};

// Groups endpoints
export const GROUP_ENDPOINTS = {
  GROUPS: '/papi/secure/groups',
  GROUPS_BY_USER: '/papi/secure/groups/by-user',
  GROUP_DESIGNATIONS: '/papi/secure/groups/designations/:groupID',
  GROUP_DESIGNATIONS_EXPORT: '/papi/secure/groups/designations/export/:groupID',
  GROUP_INFO: '/papi/secure/group/:groupID/info',
  GROUP_PATIENT_EPISODE_COST_SERVICE_CATEGORY_SUMMARY_REPORT: '/papi/secure/groups/patientEpisodeCostReport',
  GROUP_PATIENT_TOTAL_COST_SERVICE_CATEGORY_SUMMARY_REPORT: '/papi/secure/groups/patientTotalCostReport',
  GROUP_QUALITY_MEASURE_DETAILS_REPORT: '/papi/secure/groups/qualityMeasureReport',
  GROUP_REPORT_TYPES: '/papi/secure/groups/reportTypes',
  GROUP_SUMMARY_DATA: '/papi/secure/group/:groupID/summary',
  GROUP_SUMMARY_EXPORT: '/papi/secure/group/:groupID/export',
  GROUP_SUMMARY_PHYSICIANS: '/papi/secure/groups/physicians',
  GROUP_TIN_REPORT: '/papi/secure/groups/group-tin-report',
};

// Physicians endpoints
export const PHYSICIAN_ENDPOINTS = {
  MY_PHYSICIANS: '/papi/secure/my-physicians',
  SEARCH_PHYSICIANS: '/papi/secure/physicians',
};

// Quality endpoints
export const QUALITY_ENDPOINTS = {
  QUALITY_MEASURE_ATTRIBUTION: '/papi/secure/quality/recon/attribution/services',
  QUALITY_MEASURE_CONDITIONS: '/papi/secure/quality/measure-conditions',
  QUALITY_MEASURE_DETAIL: '/papi/secure/quality/measure-detail',
  QUALITY_MEASURE_POPULATIONS: '/papi/secure/quality/measure-populations',
  QUALITY_MEASURE_REPORT: '/papi/secure/odm/quality-measure/export',
  QUALITY_PATIENT_DETAIL_REPORT: '/papi/secure/odm/quality-patient/export',
  QUALITY_PATIENTS: '/papi/secure/quality/patient-detail',
  QUALITY_RECON_ATTRIBUTION: '/papi/secure/quality/recon/attribution',
  QUALITY_RECON_COMPLIANCE: '/papi/secure/quality/recon/compliance',
  QUALITY_RECON_COMPLIANCE_ATTACHMENT: '/papi/secure/quality-measure/recon/compliance/attachment',
  QUALITY_RECON_COMPLIANCE_RULES: '/papi/secure/quality/recon/compliance/rules',
  QUALITY_RECON_EXCLUSION: '/papi/secure/quality/recon/exclusion',
  QUALITY_RECON_EXCLUSION_ATTACHMENT: '/papi/secure/quality-measure/recon/exclusion/attachment',
  QUALITY_RECON_EXCLUSION_RULES: '/papi/secure/quality/recon/exclusion/rules',
  QUALITY_SERVICE_DETAILS: '/papi/secure/quality/service-detail',
};

// Reports endpoints
export const REPORT_ENDPOINTS = {
  PATIENT_TOTAL_COST_DETAIL_REPORT: '/papi/secure/odm/cost-total/export',
  PATIENT_EPISODE_COST_DETAIL_REPORT: '/papi/secure/odm/physicians/episodeCostPatientDetail',
  PHYSICIAN_PATIENT_TOTAL_COST_REPORT: '/papi/secure/odm/physicians/patientTotalCostReport',
  PATIENT_EPISODE_COST_SERVICE_CATEGORY_REPORT: '/papi/secure/odm/physicians/episodeCostServiceCategory',
};

// Combine all endpoints into a single object for convenience
export const ENDPOINTS = {
  ...ABOUT_ENDPOINTS,
  ...DELEGATE_ENDPOINTS,
  ...AUTH_ENDPOINTS,
  ...CONTENT_ENDPOINTS,
  ...CASE_ENDPOINTS,
  ...COMM_CENTER_ENDPOINTS,
  ...COST_EPISODE_ENDPOINTS,
  ...COST_PATIENT_ENDPOINTS,
  ...DESIGNATION_ENDPOINTS,
  ...FAQ_ENDPOINTS,
  ...GROUP_ENDPOINTS,
  ...PHYSICIAN_ENDPOINTS,
  ...QUALITY_ENDPOINTS,
  ...REPORT_ENDPOINTS
};

export default ENDPOINTS;
